// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1CttT","image-wrapper":"_2wfPz","content-wrapper":"P6ETr","headline":"_2eJ3E","content":"_3NcDD","button":"_3N4SK","image":"_1l8hb","close-button":"_2nwkr"};